import { Button, Dialog } from "zhihao-ui-react";
import { useState, type ReactNode } from "react";

export interface ZhMessageBoxProps {
    open: boolean;
    title?: ReactNode;
    tip?: ReactNode;
    submitText?: string;
    cancelText?: string;
    onCancel: () => void;
    onSubmit: () => void | Promise<void>;
}

/** 对应 Vue `zhMessageBox`：弹层和按钮均直接复用 zhihao-ui-react。 */
export function ZhMessageBox({
    open,
    title = "提示",
    tip,
    submitText = "提交",
    cancelText = "取消",
    onCancel,
    onSubmit
}: ZhMessageBoxProps) {
    const [submitting, setSubmitting] = useState(false);

    /** 提交期间保留弹窗并阻止重复请求，成功后由调用方关闭。 */
    const submit = async () => {
        setSubmitting(true);
        try {
            await onSubmit();
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog
            className="zh-message-box-dialog"
            open={open}
            width={430}
            title={title}
            closeOnClickModal={false}
            destroyOnClose
            onClose={onCancel}
            footer={<>
                <Button onClick={onCancel}>{cancelText}</Button>
                <Button color="primary" loading={submitting} onClick={() => void submit()}>{submitText}</Button>
            </>}
        >
            {tip ? <div className="zh-message-box-dialog__tip">{tip}</div> : null}
        </Dialog>
    );
}
